import request from '@/utils/request'

//获取初始化皮肤，强制>用户>默认
export function queryByInit(){
    return request({
        url: `/theme/queryByInit`,
        method: 'get'
    })
}

//查询所有主题皮肤
export function queryAll(){
    return request({
        url: `/theme/queryAll`,
        method: 'get'
    })
}

//用户设置主题皮肤
export function saveUserTheme(data){
    return request({
        url: `/themeUser`,
        method: 'post',
        data:data
    })
}

// 查询主题管理列表
export function listTheme(query) {
    return request({
      url: '/theme/list',
      method: 'get',
      params: query
    })
  }
  
  // 查询主题管理详细
  export function getTheme(id) {
    return request({
      url: '/theme/' + id,
      method: 'get'
    })
  }
  
  // 新增主题管理
  export function addTheme(data) {
    return request({
      url: '/theme',
      method: 'post',
      data: data
    })
  }
  
  // 修改主题管理
  export function updateTheme(data) {
    return request({
      url: '/theme',
      method: 'put',
      data: data
    })
  }
  
  // 删除主题管理
  export function delTheme(id) {
    return request({
      url: '/theme/' + id,
      method: 'delete'
    })
  }